import React, { useState } from 'react';
import './PageFooter.css';
import { Link } from 'react-router-dom';

const SocialIcon = ({ children, href = '#' }) => (
  <a href={href} className="footer-social-icon" target="_blank" rel="noopener noreferrer">
    {children}
  </a>
);

const FooterColumn = ({ title, children }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={`footer-col${open ? ' open' : ''}`}>
      <h4 className="footer-col-header" onClick={() => setOpen(prev => !prev)}>
        {title}
        <span className="footer-col-chevron">&rsaquo;</span>
      </h4>
      <div className="footer-col-links">{children}</div>
    </div>
  );
};

const PageFooter = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-inner">
        {/* Main content */}
        <div className="footer-main">
          {/* Left — Brand zone */}
          <div className="footer-brand">
            <div className="footer-logo">ApplyAI</div>
            <p className="footer-tagline">Automated internship applications</p>

            {/* Newsletter */}
            <div className="footer-newsletter">
              <p className="footer-newsletter-label">Get job search tips & product updates</p>
              <div className="footer-newsletter-row">
                <input type="email" placeholder="Enter your email" className="footer-newsletter-input" />
                <button className="footer-newsletter-btn">Subscribe</button>
              </div>
              <p className="footer-newsletter-note">No spam. Unsubscribe anytime.</p>
            </div>

            {/* Social icons */}
            <div className="footer-social">
              <SocialIcon>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"/></svg>
              </SocialIcon>
              <SocialIcon>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>
              </SocialIcon>
              <SocialIcon>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
              </SocialIcon>
              <SocialIcon>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>
              </SocialIcon>
            </div>

            {/* Status */}
            <div className="footer-status">
              <span className="footer-status-dot" />
              All systems operational
            </div>
          </div>

          {/* Right — Link columns */}
          <div className="footer-links-area">
            <FooterColumn title="Product">
              <Link to="/features">Features</Link>
              <Link to="/pricing">Pricing</Link>
              <Link to="/changelog">Changelog</Link>
              <a href="/" onClick={(e) => e.preventDefault()}><span>API</span> <span className="footer-soon-badge">Soon</span></a>
            </FooterColumn>
            <FooterColumn title="Company">
              <Link to="/about">About Us</Link>
              <Link to="/blog">Blog</Link>
              <Link to="/careers"><span>Careers</span> <span className="footer-hiring-badge">Hiring</span></Link>
            </FooterColumn>
            <FooterColumn title="Resources">
              <Link to="/help">Help Center</Link>
              <Link to="/privacy-policy">Privacy Policy</Link>
              <Link to="/terms-of-service">Terms of Service</Link>
              <Link to="/contact">Contact</Link>
            </FooterColumn>
          </div>
        </div>


        {/* Copyright bar */}
        <div className="footer-copyright">
          <span className="footer-copyright-text">&copy; {year} ApplyAI. All rights reserved.</span>
          <div className="footer-copyright-links">
            <Link to="/privacy-policy">Privacy</Link>
            <span>&middot;</span>
            <Link to="/terms-of-service">Terms</Link>
            <span>&middot;</span>
            <a href="/" onClick={(e) => e.preventDefault()}>Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PageFooter;
